import type { AIResultViewedConnectorInfo } from '@atlassian/conversation-assistant-instrumentation/types/analytics';
import type { Sources } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const extractConnectorInfo = (
	sources?: Sources,
): AIResultViewedConnectorInfo | undefined => {
	const connectorInfo = sources
		?.map<AIResultViewedConnectorInfo[number] | undefined>((source) => {
			const { ari } = source;
			const { provider_id, connector_product, connector_type, searchRetrievalType, sourceProduct } =
				source.connector_info ?? source.connectorInfo ?? {};

			if (
				!provider_id &&
				!connector_product &&
				!connector_type &&
				!searchRetrievalType &&
				!sourceProduct
			) {
				return undefined;
			}

			return {
				...(ari && { ari }),
				...(provider_id && { provider_id }),
				...(connector_product && { connector_product }),
				...(connector_type && { connector_type }),
				...(searchRetrievalType && { search_retrieval_type: searchRetrievalType }),
				...(sourceProduct && { source_product: sourceProduct }),
			};
		})
		.filter((value): value is AIResultViewedConnectorInfo[number] => Boolean(value));

	return connectorInfo?.length ? connectorInfo : undefined;
};
